import { useUniversalEntityPageContext } from "../UniversalEntityPage/contexts/UniversalEntityPageContext";
import type { AuthenticatedUser } from "@/lib/types/unified";
import type React from "react";

export type GroupingViewMode = "table" | "grouped" | "cards" | "board";

export interface GroupingPageContextValues {
  viewMode: GroupingViewMode;
  appUser: AuthenticatedUser | undefined;
  BoardViewComponent: React.ComponentType | undefined;
}

const DEFAULT_CONTEXT: GroupingPageContextValues = {
  viewMode: "table",
  appUser: undefined,
  BoardViewComponent: undefined,
};

/**
 * Reads optional UniversalEntityPage context without throwing when absent.
 */
export function useGroupingPageContext(): GroupingPageContextValues {
  try {
    const context = useUniversalEntityPageContext();
    return {
      viewMode: context.viewModeState.viewMode,
      appUser: context.auth.appUser,
      BoardViewComponent: context.pageConfig.customComponents?.boardView,
    };
  } catch {
    return DEFAULT_CONTEXT;
  }
}
